import { render, staticRenderFns } from "./AlumniStories.vue?vue&type=template&id=34752c8a&scoped=true"
import script from "./AlumniStories.vue?vue&type=script&lang=js"
export * from "./AlumniStories.vue?vue&type=script&lang=js"
import style0 from "./alumniStories.css?vue&type=style&index=0&id=34752c8a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34752c8a",
  null
  
)

export default component.exports